import React from 'react';
import { MIcon } from '../Icon';
import { IDummyProps } from './types';
import { styled, useStyletron } from '../../Themes';
import { headerRootStyles } from './styles';
import * as meta from '../../meta-data.json';

const HeaderLogo = styled('img', ({ $theme }: any) => {
	return {
		height: '100%',
		width: 'auto',
	};
});

const HeaderContainer = ({ className, children, backgroundColor, zIndex, ...rest }: IDummyProps) => {
	const [css]: any = useStyletron();
	let cssClass = css(headerRootStyles({ backgroundColor, zIndex }));
	if (className) {
		cssClass = css(headerRootStyles({ backgroundColor, zIndex })) + ' ' + className;
	}

	return (
		<header data-epo={`epo-header-${meta.version}`} className={cssClass} {...rest}>
			{children}
		</header>
	);
};


const HeaderTitle = ({ className, ...props }: any) => {
	const [css]: any = useStyletron();
	return (<div {...props} className={`${className} ${css({
		marginBottom: '0',
		marginTop: '0',
		fontWeight: 100,
		fontFamily: 'var(--epods--font-base-semibold)',
		marginLeft: 'var(--epods--header-menu-margin-right)',
		paddingRight: '0',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
	})}`}></div>)
}

const HeaderSubContainerMain = ({ className, ...props }: any) => {
	const [css]: any = useStyletron();
	return (<div {...props} className={`${className} ${css({
		display: 'flex',
		height: '100%',
		alignItems: 'center',
		flex: 1,
	})}`}></div>)
}

const HeaderSubContainer = ({ className, ...props }: any) => {
	const [css]: any = useStyletron();
	return (<div {...props} className={`${className} ${css({
		display: 'flex',
		height: '100%',
		alignItems: 'center',
	})}`}></div>)
}

const HeaderGlobalMenu = ({ onClickDrawer }: { onClickDrawer?: (event: any) => void }) => {
	const [css]: any = useStyletron();

	const onClick = (event: MouseEvent) => {
		if (onClickDrawer) {
			onClickDrawer(event);
		}
	};

	return (
		<button
			aria-label="Global menu"
			onClick={(event: any) => onClick(event)}
			className={css({
				border: '0',
				backgroundColor: 'transparent',
				marginLeft: 'var(--epods--header-menu-margin-left)',
				padding: '0',
				display: 'inline-flex',
				cursor: 'pointer'
			})}
		>
			<MIcon icon="apps" color="var(--epods--header-menu-color)" />
		</button>
	);
};

export const View = (props: IDummyProps) => {
	const { logo, appName, globalMenu, onClickGlobalMenu, leftSide, rightSide, backgroundColor = "var(--epods--color-bg)", ...rest } = props;
	return (
		<HeaderContainer backgroundColor={backgroundColor} {...rest}>
			<HeaderSubContainerMain>
				{logo && <HeaderLogo alt="Logo European Patent Office" src={logo} />}
				{globalMenu && <HeaderGlobalMenu onClickDrawer={onClickGlobalMenu} />}
				{appName && <HeaderTitle>{appName}</HeaderTitle>}
				{leftSide}
			</HeaderSubContainerMain>
			<HeaderSubContainer>{rightSide}</HeaderSubContainer>
		</HeaderContainer>
	);
};
